import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SeoService } from '../service/seo.service';

@Injectable({
  providedIn: 'root'
})
export class SeoResolver implements Resolve<any> {

  constructor(private seoService: SeoService) {}
  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    let pageCode = route.data?.['pageCode'] || '';
    let key = '';
    if(pageCode == ''){
      const id: string = route.params['id'] || '';
      const pattern: boolean = /^[0-9]*$/.test(id.slice(1));
      if (id.length > 1 && id.startsWith('p') && pattern) {
        pageCode = 'product';
        key = id.slice(1);
      } 
      else if (id.length > 1 && id.startsWith('c') && pattern) {
        pageCode = 'category';
        key = id.slice(1);
      }
    }else if(pageCode == 'gallery_details'){
      const galleryId: string = route.params['galleryKey'] || '';
      pageCode = 'gallery_details';
      key = galleryId;
    }else if(pageCode == 'video_details'){
      const videoId: string = route.params['videoKey'] || '';
      pageCode = 'video_details';
      key = videoId;
    }else if(pageCode == 'blog_details'){
      const blogId: string = route.params['blogid'] || '';
      pageCode = 'blog_details';
      key = blogId;
    }else if(pageCode == 'brand_details'){
      const brandId: string = route.params['brandId'] || '';
      pageCode = 'brand_details';
      key = brandId;
    }else if(pageCode == 'promo_details'){
      const promoId: string = route.params['promoid'] || '';
      pageCode = 'promo_details';
      key = promoId;
    }
    return this.seoService.loadSeo(pageCode,key).pipe(
      catchError(() => of(null))
    );
  }
}